<script>
    import { http } from '@/system/http.js';
    import { getQueryParam } from '@/system/helpers';
    import hasSelectedProducts from '@/online_booking/new/mixins/hasSelectedProducts.js';
    import { cloneDeep, forEach } from 'lodash';
    import moment from 'moment';
    import Card from '@/online_booking/new/components/common/Card';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
    import StepCounter from '@/online_booking/new/components/common/StepCounter';
    import { bookingKeys } from '@/online_booking/new/helpers/constants';

    export default {
        mixins: [hasSelectedProducts],

        props: {
            multiple: {
                required: false,
                default: false,
            },

            permalink: {
                required: true,
                type: String,
            },
        },

        data() {
            return {
                first_step: false,
                calendars: [],
                vouchers: [],
                product_groups: [],
                calendars_count: 0,
                calendar: null,
                product: null,
                user: null,
                loading: false,
                currentProductGroupSelected: null,
            }
        },

        beforeUnmount () {
            this.$event_bus.$off('LoadData');
            this.$event_bus.$off('CalendarClicked');
            this.$event_bus.$off('booking-restart');
            this.$event_bus.$off('ProductsShowed');
            this.$event_bus.$off('CalendarsShowed');
            this.$event_bus.$off('giftcardSelected');
        },

        mounted() {
            this.$event_bus.$on('LoadData', (data) => {
                this.calendars = data.calendars_for_online_booking;
                this.user = data.user;
                this.vouchers = data.vouchers ? data.vouchers : [];
                this.product_groups = data.product_groups;
                this.filterProductsBasedOnUrl();
                this.first_step = (data.online_booking_settings.first_step == 'products');
                this.calendars_count = data.calendars_for_online_booking.length;
                this.restart();
                this.openVouchersGroup();

                if (this.first_step) {
                    this.preselectProduct();
                }
            });

            this.$event_bus.$on('giftcardSelected', giftcard => {
                if (this.first_step) {
                    this.preselectProductFromGiftcard();
                }
            });

            this.$event_bus.$on('CalendarClicked', async (calendar) => {
                this.calendar = calendar;

                if (!this.first_step) {
                    if ($(window).width() < 500  && this.calendars.length > 1) {
                       setTimeout(function() {
                           $('html, body').animate({
                               scrollTop: $('#booking-accordion').offset().top
                           });
                       }, 250);
                    }

                    await this.getProducts();
                    this.preselectProduct();
                    this.preselectProductFromGiftcard();
                }
            });

            this.$event_bus.$on('booking-restart', () => {
                this.restart();
            });

            this.$event_bus.$on('CalendarsShowed', () => {
                if (!this.first_step) {
                    this.restart();
                }
            });

            this.$event_bus.$on('ProductsShowed', () => {
                if (!this.multiple) {
                    this.product = null;
                    this.$store.commit('clearProducts');
                }

                if (this.first_step) {
                    this.calendar = null;
                }
            });
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentStep', 'setSelectedValue']),

            showProducts() {
                this.triggerStateChange()
            },

            restart() {
                if (this.first_step) {
                    this.showProducts();
                } else {
                    this.$store.commit('clearProducts');
                    this.product = null;
                }
            },

            productClicked(product) {
                if (product.disabled_for_selection) {
                    return;
                }

                this.product = product;

                if (this.multiple) {
                    const indexOfProduct = this.selectedProducts.findIndex(selectedProduct => (selectedProduct.id === product.id));

                    if (indexOfProduct >= 0) {
                        this.$store.commit('removeProductAtIndex', indexOfProduct);
                    } else {
                        this.$store.commit('addProduct', product);
                    }

                    if (this.hasSingleProduct) {
                        this.continueToNextStep();
                    }
                } else {
                    this.$store.commit('clearProducts');
                    this.$store.commit('addProduct', product);
                    this.continueToNextStep();
                }
            },

            getDateFormatted(date) {
                if (date) {
                    return moment(date).locale(moment_locale).format('LL');
                }

                return '';
            },

            async getProducts() {
                this.loading = true;

                return http.post('/online_booking/get_products_markup', {
                        calendar_id: this.calendar.id,
                        permalink: this.permalink
                    })
                    .then(({data}) => {
                        this.vouchers = data.vouchers ? data.vouchers : [];
                        this.product_groups = data.product_groups;
                        this.filterProductsBasedOnUrl();
                        this.showProducts();
                        this.loading = false;
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                    });
            },

            continueToNextStep() {
                if (this.hasSelectedProducts) {
                    if (this.hasAddonsAvailableToSelect) {
                        this.$event_bus.$emit('productsChosenGoToAddons');
                    } else {
                        this.$event_bus.$emit('productsChosen');
                    }
                }
            },

            isProductSelected(product) {
                return this.$store.getters.hasSelectedProduct(product);
            },

            preselectProduct() {
                if (getQueryParam('service')) {
                    let service_chosen_id = parseInt(getQueryParam('service'));

                    setTimeout(() => {
                        this.selectProductById(service_chosen_id);
                    }, 500);
                }
            },

            preselectProductFromGiftcard() {
                if (this.giftcard && this.giftcard.product_id) {
                    setTimeout(() => {
                        this.selectProductById(this.giftcard.product_id);
                    }, 500);
                }
            },

            selectProductById(product_id) {
                forEach(this.product_groups, (product_group) => {
                    forEach(product_group.products, (product) => {
                        if (product.id === product_id) {
                            this.$store.commit('clearProducts');
                            this.productClicked(product);
                            this.continueToNextStep();
                        }
                    });
                });
            },

            sortByName(itemA, itemB) {
                if (itemA.name.toLowerCase() > itemB.name.toLowerCase()) {
                    return 1;
                }
                if (itemA.name.toLowerCase() < itemB.name.toLowerCase()) {
                    return -1;
                }
                if (itemA.name.toLowerCase() === itemB.name.toLowerCase()) {
                    return 0;
                }
            },

            sortByOrder(itemA, itemB) {
                if (itemA.order > itemB.order) {
                    return 1;
                }
                if (itemA.order < itemB.order) {
                    return -1;
                }
                if (itemA.order === itemB.order) {
                    return this.sortByName(itemA, itemB);
                }
            },

            triggerStateChange () {
                this.setCurrentStep('products');
            },

            productGroupClicked(index) {
                if (this.currentProductGroupSelected === index) {
                    this.currentProductGroupSelected = null;
                } else {
                    this.currentProductGroupSelected = index;
                }
            },

            openVouchersGroup () {
                if (this.filteredVouchers.length > 0) {
                    this.currentProductGroupSelected = 'voucher';
                }
            },

            filterProductsBasedOnUrl() {

                // Grab the services URL query parameter
                let servicesToDisplay = new URLSearchParams(window.location.search).get('services');

                // Check if we have services to filter by their ID from the URL
                if(servicesToDisplay) {

                    // Convert IDs to an array of integers
                    servicesToDisplay = servicesToDisplay.split(',').map(Number);

                    // Loop through each product group and filter out products...
                    this.product_groups = this.product_groups.map(productGroup => {
                        if (productGroup.products) {
                            productGroup.products = productGroup.products.filter(product => {
                                const isProductIdInURL = servicesToDisplay.includes(product.id)

                                if (!isProductIdInURL) return false;

                                if (this.calendar !== null) {
                                    return product.calendars.some(cal => cal.id === this.calendar.id)
                                }

                                return isProductIdInURL
                            });
                        }

                        if (productGroup.vouchers) {
                            productGroup.vouchers = productGroup.vouchers.filter(voucher => {
                                return !voucher.is_for_events && voucher.product && servicesToDisplay.includes(voucher.product.id);
                            });
                        }

                        return productGroup;
                    });
                }
            },
        },

        computed: {
            ...mapState('OnlineBooking', ['currentStep']),
            ...mapGetters('OnlineBooking', ['getPreviousStepId', 'currentStepNumber', 'totalStepCount']),

            hasServiceGiftcardApplied() {
                return this.giftcard !== null && this.giftcard.product_id !== null;
            },

            filteredVouchers() {
                return this.vouchers.sort(this.sortByOrder);
            },

            filteredProductGroups() {
                let allowedCalendarIds = this.allowedCalendarIds;

                let filteredProductGroups = cloneDeep(this.product_groups)
                    .filter(productGroup => 'products' in productGroup)
                    .map(productGroup => {
                        productGroup.products = productGroup.products.map(product => {
                            // figure out if the product is selectable.
                            // if not, add an attribute to disable the product from selection
                            let hasAllowedCalendars = product.calendars.filter(cal => allowedCalendarIds.includes(cal.id)).length > 0;

                            if (!hasAllowedCalendars) {
                                product.disabled_for_selection = true
                            } else if (this.hasServiceGiftcardApplied && this.giftcard.product_id !== product.id && !this.multiple) {
                                product.disabled_for_selection = true
                            } else {
                                product.disabled_for_selection = false
                            }

                            return product;
                        }).sort(this.sortByOrder);

                    return productGroup;
                });


                let allProductGroupsEmpty = filteredProductGroups.every(group => {
                    return Array.isArray(group.products) && group.products.length === 0;
                });

                if(allProductGroupsEmpty) {
                    return [];
                }

                return filteredProductGroups;
            },

            allowedCalendarIds() {
                if (this.calendar) {
                    return [this.calendar.id];
                }

                let calendarForOnlineBook = this.calendars.map(calendar => calendar.id);
                var allowedCalendarIds = [].concat(calendarForOnlineBook);

                if (this.hasSelectedProducts) {
                    this.selectedProducts.forEach(product => {
                        let productCalendars = product.product ? product.product.calendars : product.calendars;
                        let productCalendarIds = productCalendars.map(calendar => calendar.id);

                        allowedCalendarIds = allowedCalendarIds.filter(calendarId => {
                            return productCalendarIds.includes(calendarId);
                        });
                    });
                }

                return allowedCalendarIds;
            },

            selectedProductNames() {
                return this.selectedProducts.map(product => product.name).join(', ');
            },

            isProductStepActive () {
                return this.currentStep === 'products';
            },

            hasSingleProduct () {
                return this.product_groups.length === 1
                    && this.product_groups[0].products.length === 1
                    && this.vouchers.length === 0;
            }
        },

        watch: {
            isProductStepActive (newValue) {
                if (newValue) {
                    this.$event_bus.$emit('ProductsShowed');
                    window.location.hash = 'choose-service';
                }
            },

            selectedProductNames(newValue) {
                this.setSelectedValue({
                    key: bookingKeys.PRODUCTS,
                    value: newValue
                })
            }
        },

        components: {
            StepCounter,
            Card,
            PreviousButton,
        },
    };

</script>


<template>
    <div class="products-container" v-show="isProductStepActive">
        <card class="p-0 overflow-hidden rounded-lg" id="choose-product-panel">
            <h4 class="section-title">
                <step-counter :current="currentStepNumber" :total="totalStepCount" />
                {{ trans('online_booking.choose_product') }}
            </h4>
            <div
                id="collapseProducts"
                role="tabpanel"
                aria-labelledby="headingProducts"
                data-parent="#booking-accordion"
                class="pt-6"
            >
                <div
                    class="panel-body p-0"
                    id="products-accordion"
                    role="tablist"
                    aria-multiselectable="false"
                >
                    <div
                        v-if="filteredVouchers.length"
                        class="panel no-box-shadow"
                        :class="{'overflow-hidden': currentProductGroupSelected !== 'voucher'}"
                    >
                        <a
                            id="headingVouchers"
                            class="list-group-item list-group-item-group"
                            role="button"
                            aria-expanded="true"
                            aria-controls="collapseVouchers"
                            @click="productGroupClicked('voucher')"
                        >
                            <i class="zmdi zmdi-chevron-right mr-4" v-show="currentProductGroupSelected !== 'voucher'"></i>
                            <i class="zmdi zmdi-chevron-down mr-4" v-show="currentProductGroupSelected === 'voucher'"></i>
                            <span>{{ trans('online_booking.my_active_vouchers') }}</span>
                        </a>

                        <div
                            aria-labelledby="headingVouchers"
                            class="transition-all duration-75"
                            :class="currentProductGroupSelected === 'voucher' ? 'max-h-full opacity-1': 'max-h-0 opacity-0'"
                            data-parent="#products-accordion"
                        >
                            <a v-for="voucher in filteredVouchers" class="list-group-item" @click="productClicked(voucher)" :key="voucher.index" :class="{'disabled': voucher.disabled_for_selection, 'selected-product' : multiple && isProductSelected(voucher)}" >
                                <span v-if="multiple">
                                    <i class="zmdi zmdi-check selected"></i>
                                </span>
                                <div class="flex flex-column gap-y-2 flex-wrap">
                                    <h5 class="mt-0 mb-0">
                                        {{ voucher.name }}
                                        <i
                                            v-if="voucher.product.addons && voucher.product.addons.length > 0 && voucher.product.addons.filter(a => !!a.available_online_book).length"
                                            v-tooltip
                                            :title="trans('products.addon_tooltip_has_addons')"
                                            class="fa-regular fa-rectangle-history-circle-plus text-muted ml-3 mr-5"
                                        ></i>
                                    </h5>
                                    <div class="product-info mt-2">
                                        <span><i class="fa-regular fa-clock w-auto"></i> {{ voucher.product.time_formatted }}</span>
                                    </div>
                                </div>
                                <div class="n-color-text-weaker">
                                    <div class="small m-t-5">{{ trans('online_booking.clips_left', {clips_left: voucher.clips_left, clips: voucher.clips}) }}</div>
                                    <div class="small m-t-5" v-if="voucher.expiry_at">{{ trans('client.expiry_date') }}:  {{ getDateFormatted(voucher.expiry_at) }}</div>
                                </div>
                            </a>
                        </div>
                    </div>

                    <ep-banner class="m-5" variant="warning" v-show="filteredProductGroups.length === 0" >{{ trans('products.no_products_to_show') }}</ep-banner>

                    <div
                        v-for="(product_group, index) in filteredProductGroups"
                        :key="index"
                        class="panel no-box-shadow"
                        :class="{'overflow-hidden': filteredProductGroups.length > 0 && currentProductGroupSelected !== index}"
                    >
                        <a
                            :style="{ 'border-top: 0 !important;' : index === 1}"
                            v-show="product_groups.length > 1 && product_group.products.length > 0 || vouchers.length > 0 && product_group.products.length > 0"
                            :id="'headingProduct' + index"
                            class="truncate list-group-item list-group-item-group"
                            role="button"
                            aria-expanded="false"
                            :aria-controls="'collapseProduct' + index"
                            data-parent="#products-accordion"
                            @click="productGroupClicked(index)"
                        >
                            <i class="zmdi zmdi-chevron-right mr-4" v-show="currentProductGroupSelected !== index"></i>
                            <i class="zmdi zmdi-chevron-down mr-4" v-show="currentProductGroupSelected === index"></i>
                            <span>{{ product_group.group_name }}</span>
                        </a>

                        <div
                            :id="'collapseProduct' + index"
                            :aria-labelledby="'headingProduct' + index"
                            class="transition-all duration-75"
                            :class="currentProductGroupSelected === index || (filteredProductGroups.length === 1 && filteredVouchers.length === 0 ) ? 'max-h-full opacity-1': 'max-h-0 opacity-0'"
                            role="tabpanel"
                        >
                            <a
                                v-for="product in product_group.products"
                                class="list-group-item"
                                @click="productClicked(product)"
                                :key="product.index"
                                :class="{'disabled': product.disabled_for_selection || (multiple && giftcard && giftcard.product_id === product.id), 'selected-product' : multiple && isProductSelected(product)}"
                            >
                                <span v-if="multiple">
                                    <i class="zmdi zmdi-check selected"></i>
                                </span>
                                <div class="flex flex-column gap-y-2 flex-wrap">
                                    <h5 class="mt-0 mb-0" itemprop="name">
                                        {{ product.name }}
                                        <i
                                            v-if="product.addons.length > 0 && product.addons.filter(a => !!a.available_online_book).length"
                                            v-tooltip
                                            :title="trans('products.addon_tooltip_has_addons')"
                                            class="fa-regular fa-rectangle-history-circle-plus text-muted ml-3 mr-5"
                                        ></i>
                                    </h5>
                                    <div class="product-info mt-2">
                                        <span><i class="fa-regular fa-clock w-auto"></i> {{ product.time_formatted }}</span>
                                        <span v-if="giftcard && giftcard.product_id === product.id">
                                            &#183; <span class="label label-success">{{ trans('giftcards.free_with_giftcard') }}</span>
                                        </span>
                                        <span itemprop="offers" v-else-if="product.price > 0">
                                            <span itemprop="price" :content="product.price_in_cents_with_vat / 100" />
                                            <span itemprop="priceCurrency" :content="product.currency" />
                                            &#183; {{ product.price_formatted_with_vat }}

                                            <span v-if="product.online_payment == 1 && user.is_online_payment_active && user.can_receive_online_payments"> <span class="label label-info bg-brand-secondary text-brand-primary ml-2">{{ trans('online_payment.must_be_payed') }}</span></span>
                                        </span>
                                    </div>
                                    <div
                                        class="text-muted"
                                        itemprop="description"
                                        v-if="product.description_formatted !== ''"
                                        v-sanitize-html="product.description_formatted"
                                    ></div>
                                </div>
                            </a>
                        </div>
                    </div>

                    <transition name="open-summary">
                        <div v-if="(multiple && !hasSingleProduct) && hasSelectedProducts" id="products-summary">
                            <div class="p-6">
                                <div class="row products-summary-box">
                                    <div class="col-sm-7">
                                        <h4 class="m-t-0">{{ trans('online_booking.selected_services') }}</h4>
                                        <span v-if="hasSelectedProducts" id="selected-products">
                                                <span v-for="(product, index) in selectedProducts" :key="index">
                                                    <span
                                                        :id="`product-heading-${index}`"
                                                        class="product-heading"
                                                        :class="{'disabled': giftcard && giftcard.product_id === product.id}"
                                                    >
                                                        <span>{{ product.name }}</span>
                                                        <a @click="$store.commit('removeProductAtIndex', index)" class="flex items-center n-color-text-weak">
                                                            <i class="fa-regular fa-close"></i>
                                                        </a>
                                                    </span>
                                                </span>
                                            </span>
                                    </div>
                                    <div class="text-right hidden-xs m-t-10" :class="{'col-sm-3': totalProductsPrice, 'col-sm-5': !totalProductsPrice}">
                                        <h5 class="m-t-0">{{ trans('global.duration') }}</h5>
                                        <span>{{ totalProductsDurationFormatted }}</span>
                                    </div>
                                    <div class="col-sm-2 hidden-xs text-right m-t-10" v-if="totalProductsPrice">
                                        <h5 class="m-t-0">{{ trans('global.price') }}</h5>
                                        <span>{{ totalProductsPriceFormatted }}</span>
                                    </div>
                                    <div class="col-xs-12 hidden-sm hidden-md hidden-lg text-center m-t-10">
                                        <span style="color: #555;"><i class="zmdi zmdi-time"></i> {{ totalProductsDurationFormatted }} · {{ totalProductsPriceFormatted }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>

                </div>
            </div>
            <div class="signup-buttons flex justify-between flex-wrap gap-6 p-6" v-if="!first_step || (multiple && !hasSingleProduct)">
                <previous-button :previous-step-id="getPreviousStepId" />

                <button
                    v-show="!hasSingleProduct && multiple"
                    class="btn btn-custom"
                    @click="continueToNextStep()"
                    :disabled="!selectedProductNames"
                >
                    <span class="hidden md:inline">
                        {{ hasAddonsAvailableToSelect ? trans('products.continue_to_addons') : trans('global.continue') }}
                    </span>
                    <span class="md:hidden">
                        <!-- showing a continue button on mobile always -->
                        {{ trans('global.continue') }}
                    </span>
                    <i class="zmdi zmdi-arrow-right ml-3"></i>
                </button>
            </div>
        </card>
    </div>
</template>

<style lang="scss" scoped>
    .label {
        vertical-align: 1px;
    }
</style>
